import requestClient from '../config/axios'
 import { handleError } from '../lib/utilities'
 
export const bankList = async ( ) => {
  
    return await requestClient
      .get(`/banking/bank-list`)
      .catch(handleError) 
}
